import { detectTenant } from "../lib/tenant";

export default function TokushohoPage() {
  const shopUrl = window.location.origin;
  const { supportEmail } = detectTenant();

  const rows: { ja: string; en: string; content: React.ReactNode }[] = [
    {
      ja: "販売業者",
      en: "Seller",
      content: "Chlorine合同会社（Chlorine G.K.）",
    },
    {
      ja: "運営統括責任者",
      en: "Representative",
      content: "陳顗禧（Chen I-Hsi）",
    },
    {
      ja: "所在地",
      en: "Address",
      content: "Tokyo, Japan",
    },
    {
      ja: "電話番号",
      en: "Phone",
      content: (
        <>
          メールにてお問い合わせください。確認後、遅滞なくお知らせいたします。
          <br />
          <span className="text-gray-500 text-sm">
            Please contact us by email first. We will provide our phone number without delay upon request.
          </span>
        </>
      ),
    },
    {
      ja: "メールアドレス",
      en: "Email",
      content: (
        <a href={`mailto:${supportEmail}`} className="text-brand-600 hover:underline">
          {supportEmail}
        </a>
      ),
    },
    {
      ja: "販売URL",
      en: "Shop URL",
      content: (
        <a href={shopUrl} className="text-brand-600 hover:underline">
          {shopUrl}
        </a>
      ),
    },
    {
      ja: "販売価格",
      en: "Prices",
      content: (
        <>
          各商品ページに記載の価格（消費税込み）
          <br />
          <span className="text-gray-500 text-sm">
            As listed on each product page (tax included).
          </span>
        </>
      ),
    },
    {
      ja: "商品代金以外の必要料金",
      en: "Additional Charges",
      content: (
        <>
          送料：ご注文時に表示される金額
          <br />
          <span className="text-gray-500 text-sm">
            Shipping fees as shown at checkout. No other additional charges.
          </span>
        </>
      ),
    },
    {
      ja: "代金の支払い方法",
      en: "Payment Methods",
      content: (
        <>
          クレジットカード（Stripe）、PayPal
          <br />
          <span className="text-gray-500 text-sm">
            Credit card via Stripe, PayPal.
          </span>
        </>
      ),
    },
    {
      ja: "代金の支払い時期",
      en: "Payment Timing",
      content: (
        <>
          ご注文手続き完了時にお支払いが確定します。
          <br />
          <span className="text-gray-500 text-sm">
            Payment is charged at the time of order completion.
          </span>
        </>
      ),
    },
    {
      ja: "商品引き渡し時期",
      en: "Delivery",
      content: (
        <>
          ご入金確認後、3〜7営業日以内に発送いたします。
          <br />
          <span className="text-gray-500 text-sm">
            Orders are shipped within 3–7 business days after payment is confirmed.
          </span>
        </>
      ),
    },
    {
      ja: "返品・不良品について",
      en: "Returns & Defects",
      content: (
        <>
          お客様都合による返品・交換はお受けできません。
          商品に不備・破損があった場合は、商品到着後7日以内にメールにてご連絡ください。
          代替品の発送または返金にて対応いたします。
          <br />
          <span className="text-gray-500 text-sm">
            We do not accept returns or exchanges due to customer preference.
            If your order arrives damaged or defective, please contact us within 7 days of receipt.
            We will arrange a replacement or refund.
          </span>
        </>
      ),
    },
    {
      ja: "動作環境",
      en: "System Requirements",
      content: (
        <>
          本サービスのご利用には最新版のウェブブラウザを推奨します。
          <br />
          <span className="text-gray-500 text-sm">
            We recommend using an up-to-date web browser to access this site.
          </span>
        </>
      ),
    },
  ];

  return (
    <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <h1 className="font-display text-3xl font-bold text-gray-900 mb-1">
        特定商取引法に基づく表記
      </h1>
      <p className="text-gray-500 mb-8">Specified Commercial Transactions Act</p>
      <div className="w-16 h-1 bg-brand-400 rounded-full mb-10" />

      <div className="overflow-hidden rounded-xl border border-gray-200">
        <table className="w-full text-sm">
          <tbody>
            {rows.map((row, i) => (
              <tr
                key={row.ja}
                className={i % 2 === 0 ? "bg-white" : "bg-gray-50"}
              >
                <th className="w-40 sm:w-48 align-top px-5 py-4 text-left font-semibold text-gray-700 border-r border-gray-200 whitespace-nowrap">
                  <span className="block">{row.ja}</span>
                  <span className="block text-xs font-normal text-gray-400 mt-0.5">{row.en}</span>
                </th>
                <td className="px-5 py-4 text-gray-700 leading-relaxed">{row.content}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <p className="mt-8 text-xs text-gray-400 text-center">
        最終更新：{new Date().getFullYear()}年 &nbsp;·&nbsp; Last updated {new Date().getFullYear()}
      </p>
    </main>
  );
}
